import './educational-link.scss';

riot.tag2('offers-educational-link', '<div class="offers-educational-link"> <a each="{link in getLabel(\'ctas.educationalDetails\')}" href="{link.url}" target="{link.target}" class="offers-modal-link acr-cta-text" data-modal-type="large" data-tracking="{getTrackingData(trackingData.whyLeaseWithUs)}"> {link.name} </a> </div>', '', '', function(opts) {
    this.mixin('bus');
    const self = this;
    const trackingJSON = require('../../data/tracking-data');
    self.trackingData = trackingJSON.default;

    function getTrackingData(obj) {
      const jsonData = JSON.parse(JSON.stringify(obj));
      return JSON.stringify(jsonData);
    }

    self.getTrackingData = getTrackingData;
});
